interface DividerProps {
  css?: string;
}

const Divider = ({ css }: DividerProps) => {
  return (
    <div
      className={`border-bottom border-superlight ${css ? css : "my-2"}`}
      style={{ height: 1 }}
    />
  );
};

export default Divider;
